<script setup lang="ts">
import { DropdownItem, DropdownMenu } from 'vant';
import { onMounted, ref } from 'vue';
import {
  OfficialStyleFilter,
  OfficialStyleList,
  OfficialStyleSearch
} from './components/official-style';
import {
  FavoriteFabricList,
  FavoriteFabricFilter,
  FavoriteFabricSearch
} from './components/favorite-fabric';
import { Tabbar } from './components/tabbar';

type CloudType = 'official-style' | 'favorite-fabric';
const type = ref<CloudType>('official-style');

const typeOptions = [
  { text: '官方廓形库', value: 'official-style' },
  { text: '面料收藏', value: 'favorite-fabric' }
];

onMounted(async () => {
  const lastCloudPageType = localStorage.getItem('lastCloudPageType');
  type.value = lastCloudPageType as CloudType || 'official-style';
});

const onTypeChange = async () => {
  localStorage.setItem('lastCloudPageType', type.value);
};
</script>

<template>
  <div :class="$style.cloudPage">
    <div :class="$style.header">
      <OfficialStyleSearch :class="$style.headerRow" v-if="type==='official-style'" />
      <FavoriteFabricSearch :class="$style.headerRow" v-else />
      <DropdownMenu :class="$style.headerRow">
        <DropdownItem v-model="type" :options="typeOptions" @change="onTypeChange" />
        <OfficialStyleFilter v-if="type==='official-style'" />
        <FavoriteFabricFilter v-if="type==='favorite-fabric'" />
      </DropdownMenu>
    </div>
    <div :class="$style.content">
      <OfficialStyleList v-if="type==='official-style'" />
      <FavoriteFabricList v-if="type==='favorite-fabric'" />
    </div>
    <Tabbar />
  </div>
</template>

<style module>
.cloudPage {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.header {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
}

.headerRow {
  width: 100%;
}

.content {
  flex: 1;
  width: 100%;
  border-top: solid 1px #d0d0d0;
  overflow: hidden;
}

.listContainer {
  height: 100%;
  overflow-y: auto;
}

.cardList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(230px, auto) 1fr;
}

.cardList:empty {
  height: 0;
}
</style>

<style scoped>
:deep(.van-dropdown-menu__bar) {
  box-shadow: unset;
}
</style>
